import { Stack, useTheme } from "@mui/material";
import { type FC, useRef } from "react";
import { ExpandToggleButton } from "web_myplann/Shared/Components/ExpandToggleButton";
import { MultiLineText } from "web_myplann/Shared/Components/MultiLineText";
import { MyPlannHtmlContent } from "web_myplann/Shared/Components/MyPlannHtmlContent";
import { useTextTruncation } from "web_myplann/Shared/Hooks/useTextTruncation";
import {
	getHtmlContentSx,
	isHtmlContent,
} from "web_myplann/Shared/Utils/htmlContentUtils";

type Props = {
	label: string | null | undefined;
	text: string | null | undefined;
	maxLines?: number;
};

export const DetailNote: FC<Props> = ({ label, text, maxLines = 4 }) => {
	const theme = useTheme();
	const textRef = useRef<HTMLDivElement>(null);
	const { isTruncated, isExpanded, toggleExpanded } = useTextTruncation(
		textRef,
		[text],
	);

	if (!text) {
		return null;
	}

	return (
		<Stack
			direction="column"
			alignItems="left"
			gap={0.5}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.xs}
		>
			<MultiLineText variant="body2">{label}</MultiLineText>

			{isHtmlContent(text) ? (
				<MyPlannHtmlContent
					ref={textRef}
					html={text}
					sx={getHtmlContentSx({ theme, showMore: isExpanded, maxLines })}
				/>
			) : (
				<MultiLineText
					ref={textRef}
					variant="bodyMedium"
					clamp={isExpanded ? undefined : maxLines}
				>
					{text}
				</MultiLineText>
			)}

			{(isTruncated || isExpanded) && (
				<ExpandToggleButton
					isExpanded={isExpanded}
					onClick={toggleExpanded}
					fontSize={14}
				/>
			)}
		</Stack>
	);
};
